export class GetManagementBySectorAndIntervalUseCase{
  constructor(repository){
    this.repository=repository
  }

  async execute(ID_SECTOR,START,END){
    return await this.repository.getManagementByIdSectorAndInterval(ID_SECTOR,START,END)
  }
}
